<template>
  <b-modal
    id="templateDetails"
    :title="'template_details' | i18n"
    :ok-title="'Apply' | i18n"
    :cancel-title="'Cancel' | i18n"
    ok-variant="primary"
    cancel-variant="outline-secondary"
    button-size="lg"
    size="lg"
    centered
    content-class="rounded-8"
    @ok="save"
    @show="getTeams"
  >
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="templateDetails.email"
          form-group-id="Report Recipient"
          placeholder="Report Recipient"
          :required="currentRequiredFields.email"
        />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="templateDetails.emailCC"
          :tileSize="14"
          form-group-id="Report Recipient CC"
          placeholder="Report Recipient CC"
          :required="currentRequiredFields.emailCC"
        />
      </div>
      <div v-if="isTicket" class="col-lg-6 col-sm-12 col-xs-12">
        <Select
          v-model="templateDetails.defaultTeam"
          :options="allTeams"
          form-group-id="template-default-team"
          placeholder="default_team"
          :on-change="
            () => {
              templateDetails.defaultUser = null;
            }
          "
          :required="currentRequiredFields.defaultTeam"
        />
      </div>
      <div v-if="isTicket" class="col-lg-6 col-sm-12 col-xs-12">
        <Select
          v-model="templateDetails.defaultUser"
          :options="users"
          form-group-id="template-default-user"
          placeholder="default_user"
          :required="currentRequiredFields.defaultUser"
        />
      </div>
      <div v-if="isTicket" class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="templateDetails.middlewareId"
          form-group-id="Middleware ID"
          placeholder="Middleware ID"
          :required="currentRequiredFields.middlewareId"
        />
      </div>
      <div v-else class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="templateDetails.checklistNo"
          form-group-id="Checklist No"
          placeholder="Checklist No"
          :required="currentRequiredFields.checklistNo"
        />
      </div>
      <div v-if="showTeams && !isTicket" class="col-lg-6 col-sm-12 col-xs-12">
        <Multiselect
          :options="allTeams"
          form-group-id="Teams"
          placeholder="Teams"
          :placeholder-input="'select_team' | i18n"
          :on-change="(v) => (templateDetails.teams = v)"
          :required="currentRequiredFields.teams"
          :initValues="templateDetails.teams"
          :selected-name="{ single: 'team', plural: 'teams' }"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  TICKET_TEMPLATE_DETAILS_REQUIRED_FIELDS,
  REPORT_TEMPLATE_DETAILS_REQUIRED_FIELDS,
  ONE_TEMPLATE_DETAILS_REQUIRED_FIELDS,
} from '../../../../../../../../../constants';
import Multiselect from '../../../../common/multiselect';
import Select from '../../../../common/select';
import Input from '../../../../common/input';
import { ReportsMixin } from '../../../../../../mixins';

export default {
  name: 'AutomaticTranslation',
  components: { Multiselect, Select, Input },
  mixins: [ReportsMixin],
  props: {
    onSubmit: {
      type: Function,
      default: () => {},
    },
    showTeams: {
      type: Boolean,
      default: true,
    },
    isTicket: {
      type: Boolean,
      default: false,
    },
    isOne: {
      type: Boolean,
      default: false,
    },
    details: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    let currentRequiredFields = REPORT_TEMPLATE_DETAILS_REQUIRED_FIELDS;
    if (this.isOne) currentRequiredFields = ONE_TEMPLATE_DETAILS_REQUIRED_FIELDS;
    if (this.isTicket) currentRequiredFields = TICKET_TEMPLATE_DETAILS_REQUIRED_FIELDS;

    return {
      currentRequiredFields,
      templateDetails: {
        email: this.details.email || '',
        emailCC: this.details.emailCC || '',
        defaultTeam: this.details.defaultTeam || '',
        defaultUser: this.details.defaultUser || '',
        middlewareId: this.details.middlewareId || '',
        checklistNo: this.details.checklistNo || '',
        teams: this.details.teams || [],
      },
      allTeams: [],
      teamsData: [],
    };
  },
  computed: {
    users: function () {
      const currentTeamData = this.teamsData.find(({ id }) => id === this.templateDetails.defaultTeam);
      const users = currentTeamData && currentTeamData.users && currentTeamData.users.length
        ? currentTeamData.users.map((user) => ({ value: user.id, text: user.name }))
        : [];
      return users;
    },
  },
  methods: {
    save() {
      this.onSubmit(this.templateDetails);
    },
    async getTeams() {
      if (this.showTeams) {
        const teamsData = await this.reportsService.getTeams();
        this.allTeams = teamsData.map((item) => ({ value: item.id, text: item.name }));
        this.teamsData = teamsData;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.translate-actions {
  margin-bottom: 30px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-left: 15px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}

::v-deep .modal-footer {
  justify-content: space-between;
  padding: 1.5rem;
  padding-top: 0;
  border: none;
  & > button {
    padding-right: 130px;
    padding-left: 130px;
    margin: 0;
  }
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
